var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectDashboardDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0796 10.5082H14.5742C14.125 10.5082 13.761 10.8723 13.761 11.3214V21.0796C13.761 21.5287 14.125 21.8928 14.5742 21.8928H21.0796C21.5287 21.8928 21.8928 21.5287 21.8928 21.0796V11.3214C21.8928 10.8723 21.5287 10.5082 21.0796 10.5082Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0796 0.75H14.5742C14.125 0.75 13.761 1.11408 13.761 1.56319V4.83219C13.761 5.2813 14.125 5.64538 14.5742 5.64538H21.0796C21.5287 5.64538 21.8928 5.2813 21.8928 4.83219V1.56319C21.8928 1.11408 21.5287 0.75 21.0796 0.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06867 0.75H1.56319C1.11408 0.75 0.75 1.11408 0.75 1.56319V11.3214C0.75 11.7705 1.11408 12.1346 1.56319 12.1346H8.06867C8.51778 12.1346 8.88186 11.7705 8.88186 11.3214V1.56319C8.88186 1.11408 8.51778 0.75 8.06867 0.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06867 16.9974H1.56319C1.11408 16.9974 0.75 17.3614 0.75 17.8106V21.0796C0.75 21.5287 1.11408 21.8928 1.56319 21.8928H8.06867C8.51778 21.8928 8.88186 21.5287 8.88186 21.0796V17.8106C8.88186 17.3614 8.51778 16.9974 8.06867 16.9974Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDashboardDarkblue);
export default __webpack_public_path__ + "static/media/project-dashboard-darkblue.5959b727.svg";
export { ForwardRef as ReactComponent };